<template>
  <div class="register col-xl-4 mx-auto">
    <h3 class="mb-4">Register for an account</h3>
    <b-alert show variant="danger" v-if="error" class="text-left">
      <p class="mb-0">{{ error }}</p>
    </b-alert>
    <b-form-group label="Email" :state="IsFieldValid($v.user.email)" :invalid-feedback="EmailMessage('Email', $v.user.email)">
      <b-form-input v-model="$v.user.email.$model" :state="IsFieldValid($v.user.email)" />
    </b-form-group>
    <b-form-group label="Password" :state="IsFieldValid($v.user.password)" :invalid-feedback="PasswordMessage('Password', $v.user.password)">
      <b-form-input v-model="$v.user.password.$model" :state="IsFieldValid($v.user.password)" type="password" />
    </b-form-group>
    <b-form-group label="Confirm Password" :state="IsFieldValid($v.confirmPassword)" invalid-feedback="Passwords must match.">
      <b-form-input v-model="$v.confirmPassword.$model" :state="IsFieldValid($v.confirmPassword)" type="password" />
    </b-form-group>
    <b-form-group label="Name" :state="IsFieldValid($v.user.name)" :invalid-feedback="RequiredAndMaxLengthMessage('Name', $v.user.name)">
      <b-form-input v-model="$v.user.name.$model" :state="IsFieldValid($v.user.name)" />
    </b-form-group>
    <b-form-group label="Phone" :state="IsFieldValid($v.user.phone)" :invalid-feedback="RequiredAndPhoneMessage($v.user.phone)">
      <b-form-input v-model="$v.user.phone.$model" :state="IsFieldValid($v.user.phone)" />
    </b-form-group>
    <b-form-group label="Company Name" :state="IsFieldValid($v.user.companyName)" :invalid-feedback="RequiredAndMaxLengthMessage('Company Name', $v.user.companyName)">
      <b-form-input v-model="$v.user.companyName.$model" :state="IsFieldValid($v.user.companyName)" />
    </b-form-group>
    <b-form-group label="Title" :state="IsFieldValid($v.user.title)" :invalid-feedback="RequiredAndMaxLengthMessage('Title', $v.user.title)">
      <b-form-input v-model="$v.user.title.$model" :state="IsFieldValid($v.user.title)" />
    </b-form-group>
    <b-button @click="register" variant="success">
      Register
    </b-button>
  </div>
</template>

<script>
import UserService from '../services/UserService.js'
import User from '../models/User.js'
import { required, maxLength, minLength, sameAs, email } from 'vuelidate/lib/validators'
import CustomValidations from '../mixins/customValidations.js'
const phoneValidation = CustomValidations.phoneValidation
const pwValidation = CustomValidations.passwordValidation

export default {
  name: 'Register',
  data() {
      return {
        user: {},
        confirmPassword: '',
        error: ''
    }
  },
  validations() {
    return {
      user: {
        email: {
          required,
          email,
          maxLength: maxLength(256)
        },
        password: {
          required,
          pwValidation,
          minLength: minLength(15),
          maxLength: maxLength(60)
        },
        name: {
          required,
          maxLength: maxLength(50)
        },
        phone: {
          required,
          phoneValidation
        },
        companyName: {
          required,
          maxLength: maxLength(100)
        },
        title: {
          required,
          maxLength: maxLength(50)
        }
      },
      confirmPassword: {
        sameAsPassword: sameAs(function() {
          return this.user.password
        })
      }
    }
  },
  methods: {
    register() {
      this.$v.$touch()
      if (this.$v.$invalid) return

      UserService.register(this.user).then(res => {
        this.$store.dispatch('user/setUserData', res.data).then(() => {
          this.$router.push({
            name: 'home'
          })
        }) 
      }).catch(error => {
        this.error = error && error.response && error.response.data ? error.response.data : 'The account could not be created.'
      })
    }
  },
  created() {
    this.user = new User()
  }
}
</script>

<style scoped>
</style>